<template>
  <router-view></router-view>
</template>

<script setup>
</script>

<style>
html,body,#app{
  height: 100%;
  background-color: #d1c0ab;
}
button{
  height: auto;
  padding: 3px 6px;
  font-size: 12px;
  font-weight: initial;
  border: 1px solid #3370ff;
  border-radius: 3px;
  background: none;
  color: #3370ff;
  margin-left: 5px;
}
button.block{
  display: block;
  margin: auto;
  padding: 3px 20px;
  width: 70%;
}

/* #region form  */
/* 自定义cell */
.van-cell.default_sites_cell > .van-cell__value > .van-field{
  padding:0;
}
.van-cell.default_sites_cell > .van-cell__value > .van-field::after{
  border: 0
}
.van-cell.default_sites_cell .van-field{
 display: block
}
.van-cell.default_sites_cell .van-field > .van-cell__title,
.van-cell.form_line_cell .custom_sites_cell > .van-cell__title{
  display: block;
  width: 100%;
  margin-bottom: 10px;
}
.van-cell.default_sites_cell .van-field > .van-icon{
  position: absolute;
  right: 0;
  bottom: 0;
}
/* #endregion form  */
</style>
